const accessTokenKey = 'TRADLE_TOKEN_DELIVERY'

export default {
  UPDATE_TOKEN (state, newToken) {
    localStorage.setItem(accessTokenKey, newToken)
    state.token = newToken
  },
  SET_LOGGED_IN (state, payload) {
    state.isLoggedIn = payload
  },
  UPDATE_IS_LOADING (state, payload) {
    state.isLoading = payload
  },
  SET_ERROR (state, payload) {
    state.error = payload
  }
}
